module.exports = __webpack_public_path__ + "assets/images/EC.4b08d31f70fbf6445888c14bc091a7ac.png";